import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconArrowBarToRight = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill={props.color}>
    <path
      d="M6.66665 7.99906L13.3333 7.99906M6.66665 7.99906L9.33331 5.3324M6.66665 7.99906L9.33331 10.6657M2.66665 13.3324L2.66665 2.66573"
      stroke={props.color ?? colors.secondaryAction.inactiveDarker}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconArrowBarToRight;
